<template>
  <main class="signed-page">
    <div class="signed-content">
      <img
          class="signed-logo"
          :src="logo"
          alt="Chèque Intermittents"
      />
        <section
            :class="['signed-state', 'success-state', `status-${status}`]"
        >
          <img
              class="success-illustration"
              :src="successIllustration"
              alt=""
          />

          <p class="success-title">
            {{ title }}
          </p>

          <p class="success-message">
            {{ message }}<br />
            Vous pouvez fermer cet onglet et retourner sur votre espace privé.
          </p>

          <button class="return-button" type="button" @click="returnToApplication">
            Retour à l'application
          </button>
        </section>

    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Replace these paths with the real paths of your assets.
import logo from "@/assets/LogoCI.png";
import successIllustration from "@/assets/signature-success.png";

export default defineComponent({
  name: "PaymentStatus",

  data() {
    return {
      logo,
      successIllustration
    };
  },
  mounted() {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: "paybox-return",
          pbxCmd: this.reference,
          browserStatus: this.status
        },
        window.location.origin
      );
    }
    window.close();
  },
  computed: {
    status(): string {
      const status = this.$route.query.status;
      return typeof status === "string" ? status.toLowerCase() : "unknown";
    },
    reference(): string {
      const reference = this.$route.query.ref;
      return typeof reference === "string" ? reference : "";
    },
    title(): string {
      switch (this.status) {
        case "success":
          return "Paiement en cours de confirmation";
        case "failure":
          return "Paiement non accepté";
        case "cancel":
          return "Paiement annulé";
        default:
          return "Retour de paiement";
      }
    },
    message(): string {
      switch (this.status) {
        case "success":
          return "Votre paiement a été transmis et sera confirmé automatiquement.";
        case "failure":
          return "Votre tentative de paiement n'a pas été acceptée.";
        case "cancel":
          return "Vous avez annulé la tentative de paiement.";
        default:
          return "Le traitement du paiement se poursuit automatiquement.";
      }
    }
  },
  methods: {
    returnToApplication(): void {
      window.close();
      window.setTimeout(() => {
        if (!window.closed) {
          window.location.href = "/";
        }
      }, 200);
    }
  }
});
</script>

<style scoped>
.signed-page {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-height: 100vh;

  margin: 0;
  padding: 24px;

  background: #ffffff;
  box-sizing: border-box;
}

.signed-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  max-width: 460px;

  text-align: center;
  transform: translateY(-3vh);
}

.signed-logo {
  display: block;

  width: 154px;
  height: auto;

  margin-bottom: 52px;
  object-fit: contain;
}

.signed-state {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
}

.loader {
  width: 82px;
  height: 82px;

  margin-bottom: 54px;

  border: 9px solid #f2f3f4;
  border-top-color: #d8dcde;
  border-radius: 50%;

  box-sizing: border-box;
  animation: rotate-loader 0.9s linear infinite;
}

.loading-message {
  margin: 0;

  color: #212121;

  font-family: Inter, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.25;
}

.success-state {
  margin-top: -17px;
}

.success-illustration {
  display: block;

  width: 140px;
  height: 150px;

  margin-bottom: 25px;

  object-fit: contain;
}

.success-title {
  margin: 0 0 12px;

  color: #202020;

  font-family: Inter, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3;
}

.success-message {
  margin: 0;

  color: #24717a;

  font-family: Inter, Arial, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.45;
}

.return-button {
  margin-top: 28px;
  padding: 10px 20px;

  border: 0;
  border-radius: 5px;

  color: #ffffff;
  background: #24717a;

  font-family: Inter, Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
}

.return-button:hover {
  background: #1c5b63;
}

.fade-enter-active,
.fade-leave-active {
  transition:
      opacity 250ms ease,
      transform 250ms ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@keyframes rotate-loader {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 600px) {
  .signed-page {
    padding: 20px;
  }

  .signed-content {
    transform: translateY(-2vh);
  }

  .signed-logo {
    width: 145px;
    margin-bottom: 46px;
  }

  .loader {
    width: 74px;
    height: 74px;

    margin-bottom: 45px;
    border-width: 8px;
  }

  .loading-message,
  .success-title,
  .success-message {
    font-size: 14px;
  }
}
</style>
